'use client';

import { useEffect, useState } from 'react';
import { registrarOyenteAvisos, type AvisoCentralData } from '@/lib/avisoCentral';
import AvisoErrorCentral from './AvisoErrorCentral';
import AvisoExitoCentral from './AvisoExitoCentral';

// Host ÚNICO de los avisos centrados (montado en el layout raíz, en lugar del
// <Toaster/> de sonner). Muestra el último aviso emitido por lib/avisoCentral;
// se cierra con el botón o tocando el fondo. Se renderizan ambos componentes
// (con mensaje null cuando no aplican) para conservar la animación de salida.
export default function AvisoCentralHost() {
  const [aviso, setAviso] = useState<AvisoCentralData | null>(null);
  useEffect(() => registrarOyenteAvisos(setAviso), []);

  const cerrar = () => setAviso(null);
  const esError = aviso?.tipo === 'error';
  const esInfo = aviso?.tipo === 'info';

  return (
    <>
      <AvisoErrorCentral
        mensaje={esError ? aviso.mensaje : null}
        detalle={esError ? aviso.detalle : undefined}
        titulo="No se pudo completar"
        accion="Aceptar"
        onCerrar={cerrar}
      />
      <AvisoExitoCentral
        mensaje={aviso && !esError ? aviso.mensaje : null}
        detalle={aviso && !esError ? aviso.detalle : undefined}
        titulo={esInfo ? 'Atención' : 'Listo'}
        onCerrar={cerrar}
      />
    </>
  );
}
